import "../styles/admin.css";

export default function AdminLoadingOverlay({
  open,
  isOpen,
  title = "Processing...",
  message = "Please wait while FleetX completes this action.",
  variant = "default",
}) {
  if (!open && !isOpen) return null;

  return (
    <div className={`admin-loading-overlay admin-loading-overlay--${variant}`}>
      <div
        className="admin-loading-overlay__card"
        role="alertdialog"
        aria-modal="true"
        aria-live="assertive"
        aria-labelledby="admin-loading-overlay-title"
        aria-describedby={message ? "admin-loading-overlay-message" : undefined}
      >
        <div className="admin-loading-overlay__spinner" aria-hidden="true" />
        <h3 id="admin-loading-overlay-title">{title}</h3>
        {message ? <p id="admin-loading-overlay-message">{message}</p> : null}
      </div>
    </div>
  );
}
